import { FaMinus, FaPlus } from "react-icons/fa";

const MIN_ZOOM = 0.5;
const MAX_ZOOM = 2;
const ZOOM_STEP = 0.1;

function CanvasZoomControls({ zoom, onZoomChange, onFit }) {
    const changeZoom = amount => {
        const nextZoom = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, zoom + amount));
        onZoomChange(Number(nextZoom.toFixed(1)));
    };

    return (
        <div className="canvas-zoom-controls" role="group" aria-label="Zoom del lienzo">
            <button type="button" aria-label="Alejar" title="Alejar" disabled={zoom <= MIN_ZOOM} onClick={() => changeZoom(-ZOOM_STEP)}>
                <FaMinus aria-hidden="true" />
            </button>
            <output aria-label="Nivel de zoom">{Math.round(zoom * 100)}%</output>
            <button type="button" aria-label="Acercar" title="Acercar" disabled={zoom >= MAX_ZOOM} onClick={() => changeZoom(ZOOM_STEP)}>
                <FaPlus aria-hidden="true" />
            </button>
            <button type="button" className="canvas-zoom-fit" onClick={onFit}>
                Ajustar
            </button>
        </div>
    );
}

export default CanvasZoomControls;
